module.exports = {
      id: "whatsapp-icon-usage",
      viewBox: "0 0 24.99 25.091",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#whatsapp-icon",
      toString: function () {
        return this.url;
      }
    }